var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckOrangecircleicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4969 10.3333C18.8775 12.2011 18.6063 14.1428 17.7285 15.8348C16.8507 17.5268 15.4193 18.8667 13.6732 19.6311C11.927 20.3955 9.97162 20.5381 8.13301 20.0353C6.29441 19.5325 4.68375 18.4145 3.56966 16.8678C2.45556 15.3212 1.90536 13.4394 2.01082 11.5361C2.11627 9.63294 2.87099 7.8234 4.14914 6.4093C5.42728 4.9952 7.15158 4.06202 9.03448 3.76537C10.9174 3.46872 12.8451 3.82654 14.4961 4.77916",
    stroke: "url(#paint0_linear_5682_4130)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83008 11.1666L10.3301 13.6666L18.6634 5.33331",
    stroke: "url(#paint1_linear_5682_4130)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5682_4130",
    x1: -7.17918,
    y1: 1.39109,
    x2: 11.4351,
    y2: -4.51984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4543A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5682_4130",
    x1: 1.86489,
    y1: 4.19695,
    x2: 13.2449,
    y2: -0.500862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4543A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrangecircleicon);
export default __webpack_public_path__ + "static/media/check-orangecircleicon.5193a40c1ea6d009a4eb802099ebf87d.svg";
export { ForwardRef as ReactComponent };